module.exports = __webpack_public_path__ + "img/TV_clean_box29.1c412f57.jpg";